<script setup>
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { ref } from 'vue';

import AppMenuItem from './AppMenuItem.vue';

const store = useStore()

defineProps({
  visible: Boolean
})


const router = useRouter()
const { t } = useI18n()

const authenticated = computed(() => store.getters['auth/check'])
const navItems = computed(() => store.getters['navigation/navItems'])
const user = computed(() => store.getters['auth/user'])

const logout = async () => {
  await store.dispatch('auth/logout')
  router.push({ name: 'login' })
}
</script>

<template>
    <ul class="layout-menu layout-menu--flex">
        <div class="layout-menu__main">
            <template v-for="(item, i) in navItems" :key="item">
                <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
                <li v-if="item.separator" class="menu-separator"></li>
            </template>
        </div>

        <template v-if="authenticated">
            <li class="layout-root-menuitem layout-menu__footer ml-2">
                <ul class="layout-submenu">
                    <li class="">
                        <router-link :to="{ name: 'settings.profile' }" class="">
                            {{ $t('core.settings') }}
                        </router-link>
                    </li>
                    <li>
                        <a @click.prevent="logout" class="" href="#">
                            {{ $t('core.logout') }}
                        </a>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<style lang="scss" scoped></style>
